import React from 'react';
import moment from 'moment';
import Header, { headerItemsLabels } from '../../../../../../mat/js/components/Common/Header/header';
import { autoSchedulingStatuses } from '../../../../../../mat/js/enums/autoSchedulingStatuses';
import SchedulerKPIs from '../SchedulerKpis/schedulerKpis';
import { PL_DialogWrapper } from 'infrastructure/js/components/Dialog/dialog';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import PrintPDFDialog from '../../Dialogs/PrintPDFDialog/printPDFDialog';
import SchedulerProgressIndicator from './schedulerProgressIndicator';

import './schedulerHeader.scss';

export default class SchedulerHeader extends React.Component {
  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.scheduler.gantt.');
    this.state = {
      showPrintPDFDialog: false,
      currentHorizonIndex: 1,
      exportStarted: false,
    };
  }

  getHeaderItems() {
    const { onScrollToNow, toggleFullScreen } = this.props.actions;
    const backtrackList = this.props.backtrackList;
    const schedulerInstance = this.props.schedulerInstance;

    return {
      buttons: [
        {
          id: 'printButton',
          icon: 'pl pl-print',
          className: 'gantt-header-button',
          // tooltip: headerItemsLabels.PRINT_GANTT,
          tooltipContainer: this,
          disabled: this.state.exportStarted,
          action: () => {
            this.togglePrintDialog(true);
          },
        },
        ...(!this.props.fullScreenMode
          ? [
              {
                id: 'undoButton',
                tooltip: headerItemsLabels.UNDO,
                tooltipContainer: this,
                icon: 'fa fa-undo',
                className: 'gantt-header-button',
                disabled: !backtrackList.undoItems.length,
                action: this.handleUndoClick,
              },
              {
                id: 'redoButton',
                tooltip: headerItemsLabels.REDO,
                tooltipContainer: this,
                icon: 'fa fa-repeat',
                className: 'gantt-header-button',
                disabled: !backtrackList.redoItems.length,
                action: this.handleRedoClick,
              },
            ]
          : []),
        {
          id: 'todayButton',
          label: headerItemsLabels.TODAY,
          className: 'no-icon',
          // disabled: !this.state.schedulerInstanceReady,
          action: onScrollToNow,
          actionData: schedulerInstance,
        },
        {
          id: 'horizonSelectButton',
          schedulerInstance,
          value: this.state.currentHorizonIndex,
          labels: this.labels,
          actions: this.onHorizonChange,
          buttonComponent: HorizonSelect,
        },
        {
          id: 'shiftPrevious',
          icon: 'pl pl-arrow-left',
          tooltip: headerItemsLabels.PREVIOUS,
          tooltipContainer: this,
          className: 'gantt-header-button',
          // disabled: !this.state.schedulerInstanceReady,
          action: this.shiftPrevious,
          actionData: schedulerInstance,
        },
        {
          id: 'shiftNext',
          icon: 'pl pl-arrow-right',
          tooltip: headerItemsLabels.NEXT,
          tooltipContainer: this,
          className: 'gantt-header-button',
          // disabled: !this.state.schedulerInstanceReady,
          action: this.shiftNext,
          actionData: schedulerInstance,
        },
        {
          id: 'zoomInButton',
          icon: 'pl pl-zoom-in',
          tooltip: headerItemsLabels.ZOOM_IN,
          tooltipContainer: this,
          className: 'gantt-header-button',
          // disabled: !(
          //   this.state.schedulerInstanceReady && this.schedulerRef.schedulerInstance.zoomLevel < this.schedulerRef.schedulerInstance.maxZoomLevel
          // ),
          action: this.zoomIn,
          actionData: schedulerInstance,
        },
        {
          id: 'zoomOutButton',
          icon: 'pl pl-zoom-out',
          tooltip: headerItemsLabels.ZOOM_OUT,
          tooltipContainer: this,
          className: 'gantt-header-button',
          // disabled: !(
          //   this.state.schedulerInstanceReady && this.schedulerRef.schedulerInstance.zoomLevel > this.schedulerRef.schedulerInstance.minZoomLevel
          // ),
          action: this.zoomOut,
          actionData: schedulerInstance,
        },
        {
          id: 'fullScreen',
          icon: 'pl pl-maximize',
          tooltip: this.props.fullScreenMode ? 'exitFullScreen' : 'showFullScreen',
          tooltipContainer: this,
          className: 'gantt-header-button',
          action: toggleFullScreen,
        },
      ],
    };
  }

  togglePrintDialog = (show) => {
    //update only when opening the dialog.
    if (show) {
      this.originalSchedulerZoom = this.props.schedulerInstance?.zoomLevel;
    }
    this.setState({
      showPrintPDFDialog: show,
    });
  };

  handleUndoClick = () => {
    const {
      backtrackList: { undoItems },
    } = this.props;
    this.props.actions.undo(undoItems);
  };

  handleRedoClick = () => {
    const {
      backtrackList: { redoItems },
    } = this.props;
    this.props.actions.redo(redoItems);
  };

  onHorizonChange = (event) => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance) {
      let newZoomLevel = +event.target.value;
      schedulerInstance.zoomLevel = newZoomLevel;

      this.setState({ currentHorizonIndex: newZoomLevel }, () => this.props.actions.updateKPIsTimeRange());
    }
  };

  shiftPrevious = () => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance) {
      schedulerInstance.shiftPrevious();
      this.props.actions.updateKPIsTimeRange();
    }
  };

  shiftNext = () => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance) {
      schedulerInstance.shiftNext();
      this.props.actions.updateKPIsTimeRange();
    }
  };

  zoomIn = () => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance && schedulerInstance.zoomLevel < schedulerInstance.maxZoomLevel) {
      let newZoomLevel = schedulerInstance.zoomLevel + 1;
      schedulerInstance.zoomLevel = newZoomLevel;

      this.setState({ currentHorizonIndex: newZoomLevel }, () => this.props.actions.updateKPIsTimeRange());
    }
  };

  zoomOut = () => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance && schedulerInstance.minZoomLevel < schedulerInstance.zoomLevel) {
      let newZoomLevel = schedulerInstance.zoomLevel - 1;
      schedulerInstance.zoomLevel = newZoomLevel;

      this.setState({ currentHorizonIndex: newZoomLevel }, () => this.props.actions.updateKPIsTimeRange());
    }
  };

  onPrintPDF = (data) => {
    const { schedulerInstance } = this.props;
    const { exportStations, exportFrom, exportTo } = data;

    this.setState({ exportStarted: true });
    const exportConfig = {};

    exportConfig.rows = exportStations;

    if (exportFrom && exportTo) {
      exportConfig.scheduleRange = 'daterange';
      exportConfig.rangeStart = exportFrom.startOf('day').toDate();
      exportConfig.rangeEnd = exportTo.endOf('day').toDate();
    }

    schedulerInstance.features.print
      .print(exportConfig)
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ exportStarted: false });
        schedulerInstance.zoomLevel = this.originalSchedulerZoom;
      });
  };

  updateSchedulerZoom = (value) => {
    const { schedulerInstance } = this.props;
    if (schedulerInstance?.zoomLevel) {
      schedulerInstance.zoomLevel = value ?? this.originalSchedulerZoom;
    }
  };

  getCurrentViewTimeRange = () => {
    const { schedulerInstance } = this.props;
    try {
      // Check if the schedulerRef is null
      if (!schedulerInstance) {
        // Return an object with startDate and endDate set to null
        return { startDate: null, endDate: null };
      }

      // Get the startDate and endDate from the scheduler's visibleDateRange property
      const { startDate, endDate } = schedulerInstance.visibleDateRange;

      // Return an object with startDate and endDate set to moment objects
      return { startDate: moment(startDate), endDate: moment(endDate) };
    } catch (ex) {
      // Log the error to the console
      console.error(ex);

      // Return an object with startDate and endDate set to null
      return { startDate: null, endDate: null };
    }
  };

  renderProgressIndicator = () => {
    const schedulingStatus = this.props?.schedulingStatus.get('status');

    const { COMPLETED, BUSY } = autoSchedulingStatuses;

    if ([COMPLETED, BUSY].includes(schedulingStatus)) {
      const { abortAsyncScheduling } = this.props.actions;
      return <SchedulerProgressIndicator actions={{ abortAsyncScheduling }} statusData={this.props.schedulingStatus} />;
    }

    return null;
  };

  render() {
    const headerItems = this.getHeaderItems();

    return (
      <div className="pl-scheduler-header">
        <div className="titles-section">
          <div className="gantt-title">{this.labels.get('header.title')}</div>
        </div>

        <SchedulerKPIs
          centerDate={this.props.schedulerInstance?.viewportCenterDate}
          metrics={this.props.metrics}
          currentKPIsTimeRange={this.props.currentKPIsTimeRange}
        />

        <div className="scheduler-actions-wrapper">
          {this.renderProgressIndicator()}
          <Header {...headerItems} />
        </div>

        <PL_DialogWrapper
          dialogComponent={PrintPDFDialog}
          show={this.state.showPrintPDFDialog}
          stations={this.props.resources}
          resolution={this.state.currentHorizonIndex}
          onPrintPDF={this.onPrintPDF}
          onDialogToggle={this.togglePrintDialog}
          updateSchedulerZoom={this.updateSchedulerZoom}
          getCurrentViewTimes={this.getCurrentViewTimeRange}
        />
      </div>
    );
  }
}

function HorizonSelect({ value, actions, labels }) {
  return (
    <div className="horizon-select">
      <select value={value} onChange={actions}>
        <option value="3">{labels.get('select.horizon.oneDay')}</option>
        <option value="2">{labels.get('select.horizon.threeDays')}</option>
        <option value="1">{labels.get('select.horizon.oneWeek')}</option>
        <option value="0">{labels.get('select.horizon.twoWeeks')}</option>
      </select>
    </div>
  );
}
